import React from "react";

function CtaBand() {
  return (
    <section className="cta-band">
      <div className="container cta-inner" data-reveal>
        <div>
          <h2>Ready to put your data and systems to work?</h2>
          <p>Tell us about your goals. We'll respond within one business day with next steps.</p>
        </div>
        <a href="#contact" className="btn-corp btn-corp-light btn-corp-lg">
          Start a conversation <i className="fa-solid fa-arrow-right" aria-hidden="true" />
        </a>
      </div>
    </section>
  );
}

export default CtaBand;
